import { render } from "./Reviews.vue?vue&type=template&id=1be0e294&ts=true"
import script from "./Reviews.vue?vue&type=script&lang=ts"
export * from "./Reviews.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__